import type { SummarySectionDb } from '@domain/schemas/endorsement-summary.schema';
import type { DynamoDBResourceSection } from '@root/@types/database';

export const isSummarySection = (section?: Pick<DynamoDBResourceSection, 'sk'>): section is SummarySectionDb =>
  Boolean(section?.sk?.startsWith('summary_sections#'));
